import { render, staticRenderFns } from "./ClientProductRow.vue?vue&type=template&id=84827e82&scoped=true&"
import script from "./ClientProductRow.vue?vue&type=script&lang=js&"
export * from "./ClientProductRow.vue?vue&type=script&lang=js&"
import style0 from "./ClientProductRow.vue?vue&type=style&index=0&id=84827e82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84827e82",
  null
  
)

export default component.exports